import React from 'react';
import '../styles/SessionExpiryModal.css';

/**
 * The last two minutes of an Orcanos session, made visible.
 *
 * Shown only while `useSessionExpiry` reports `warn` — the countdown is local, and
 * "Stay signed in" is the ONE call that deliberately extends the session server-side.
 * Doing nothing signs the user out; that is the point, so there is no × to dismiss it.
 */
function SessionExpiryModal({ secondsLeft, onStay, onLogout }) {
  const secs = Math.max(0, Math.round(secondsLeft || 0));
  const mm = Math.floor(secs / 60);
  const ss = String(secs % 60).padStart(2, '0');

  return (
    <div className="session-expiry-overlay" role="dialog" aria-modal="true" aria-live="assertive">
      <div className="session-expiry-box">
        <h3 className="session-expiry-title">Your session is about to expire</h3>
        <p className="session-expiry-text">
          You will be signed out automatically and returned to the login screen.
        </p>
        <div className="session-expiry-countdown">{mm}:{ss}</div>
        <div className="session-expiry-actions">
          <button type="button" className="session-expiry-stay" onClick={onStay}>
            Stay signed in
          </button>
          <button type="button" className="session-expiry-out" onClick={() => onLogout()}>
            Sign out now
          </button>
        </div>
      </div>
    </div>
  );
}

export default SessionExpiryModal;
